// src/pages/Clients/components/EmailScheduleTab.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Table, Popconfirm, App } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmailSchedules } from "../clientsSlice";
import { deleteEmailScheduleApi } from "../../../apiservice/hrpayroll";
import { getAccessType } from "../../../lib/functions";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";


const EmailScheduleTab = ({ onEdit }) => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { emailSchedules, loading } = useSelector((s) => s.clientsSuite);

  let [access_type, access_type_set] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const access = getAccessType("clients_entry");
    access_type_set(access);
  }, []);

  const handleDelete = async (id) => {
    await deleteEmailScheduleApi({ id });
    message.success("Email schedule deleted");
    dispatch(fetchEmailSchedules());
  };

  const columns = useMemo(
    () => [
      { title: "Employee Name", dataIndex: "user_name", key: "user_name" },
      { title: "Client Name", dataIndex: "name", key: "name" },
      { title: "Approver", dataIndex: "client_user_name", key: "client_user_name" },
      { title: "Report Day", dataIndex: "report_day", key: "report_day" },
      ...(access_type === "WRITE"
        ? [
          {
            title: "Actions",
            key: "actions",
            align: "right",
            render: (_, row) => (
              <>
                <EditOutlined
                  style={{ marginRight: 16, cursor: "pointer", color: "#1677ff" }}
                  onClick={() => onEdit(row)}
                />
                <Popconfirm
                  title="Delete Email Schedule?"
                  okText="Delete"
                  onConfirm={() => handleDelete(row.id)}
                >
                  <DeleteOutlined
                    style={{ cursor: "pointer", color: "#ff4d4f" }}
                  />
                </Popconfirm>
              </>
            ),
          },] : [])
    ],
    [access_type, onEdit]
  );

  return (
    <Table
      rowKey="id"
      dataSource={emailSchedules}
      columns={columns}
      loading={loading.schedules}
      scroll={{ x: "max-content" }}
      pagination={{
      current: currentPage,
      pageSize: pageSize,
      total: emailSchedules?.length,
      showQuickJumper: true,
      showSizeChanger: true,
      pageSizeOptions: [10, 20, 50, 100],
      onChange: (page) => {
        setCurrentPage(page);
      },
      onShowSizeChange: (_, size) => {
        setPageSize(size);   
        setCurrentPage(1);   
      },
      }}
    />
  );
};

export default EmailScheduleTab;
